import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useRef } from 'react';
import { useImpressionRef } from '@noths/polaris-client-react-hooks';
import { IconArrowBack, IconArrowForward, IconButton } from '@noths/polaris-client-ribbons-design-system';
import { toSentenceCase } from '@noths/polaris-client-utils';
import { useCarousel } from "./hooks/useCarousel";
import * as styles from "./LinkCarousel.styles";
export var LinkCarousel = function LinkCarousel(_ref) {
  var items = _ref.items,
    onItemClick = _ref.onItemClick,
    onNavigate = _ref.onNavigate,
    onVisible = _ref.onVisible,
    title = _ref.title;
  var carouselWrapperRef = useImpressionRef(function () {
    return onVisible === null || onVisible === void 0 ? void 0 : onVisible();
  });
  var carouselItems = useRef([]);
  var _useCarousel = useCarousel(carouselWrapperRef, carouselItems, onNavigate),
    showNavigation = _useCarousel.hasNavigation,
    hasNext = _useCarousel.hasNext,
    hasPrevious = _useCarousel.hasPrevious,
    _onFocus = _useCarousel.onFocus,
    onNext = _useCarousel.onNext,
    onPrevious = _useCarousel.onPrevious,
    position = _useCarousel.position;
  var createClickHandler = function createClickHandler(index) {
    return function (evt) {
      onItemClick === null || onItemClick === void 0 || onItemClick(evt, {
        index
      });
    };
  };
  return /*#__PURE__*/React.createElement(_StyledSection, _extends({}, title && {
    'aria-label': title
  }, {
    $_css: styles.linkCarousel
  }), title && /*#__PURE__*/React.createElement(_StyledH, {
    $_css2: styles.outsideCarouselHeading
  }, toSentenceCase(title)), /*#__PURE__*/React.createElement(_StyledDiv, {
    ref: carouselWrapperRef,
    $_css3: styles.carouselContentWrapper
  }, /*#__PURE__*/React.createElement(_StyledDiv2, {
    style: {
      transform: "translateX(-".concat(position, "px)")
    },
    $_css4: styles.carouselContent
  }, /*#__PURE__*/React.createElement(_StyledUl, {
    $_css5: styles.links
  }, items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(_StyledLi, {
      key: "".concat(item.href, "-").concat(item.text),
      ref: function ref(el) {
        carouselItems.current[index] = el;
      },
      $_css6: styles.itemLink
    }, /*#__PURE__*/React.createElement(_StyledA, {
      "data-active": Boolean(item.active),
      href: item.href,
      onClick: createClickHandler(index),
      onFocus: function onFocus(evt) {
        return _onFocus(evt.target);
      },
      $_css7: styles.link
    }, item.text));
  })))), showNavigation && /*#__PURE__*/React.createElement(_StyledDiv3, {
    "data-testid": "carousel-controls",
    $_css8: styles.carouselControls
  }, /*#__PURE__*/React.createElement(IconButton, {
    Icon: IconArrowBack,
    "aria-label": "Scroll to previous item",
    disabled: !hasPrevious,
    onClick: onPrevious,
    size: "small"
  }), /*#__PURE__*/React.createElement(IconButton, {
    Icon: IconArrowForward,
    "aria-label": "Scroll to next item",
    disabled: !hasNext,
    onClick: onNext,
    size: "small"
  })));
};
var _StyledSection = _styled("section")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledH = _styled2("h3")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledDiv = _styled3("div")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledDiv2 = _styled4("div")(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css4;
});
var _StyledUl = _styled5("ul")(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css5;
});
var _StyledLi = _styled6("li")(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css6;
});
var _StyledA = _styled7("a")(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css7;
});
var _StyledDiv3 = /*#__PURE__*/_styled8("div").withConfig({
  displayName: "LinkCarousel___StyledDiv3",
  componentId: "sc-75fss4-0"
})(["", ""], function (p) {
  return p.$_css8;
});